module.exports = __webpack_public_path__ + "static/media/griffith-college.3632088a.png";